/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Inline_TitleInputs */

const en_directory_submit_enrich_inline_title = /** @type {(inputs: Directory_Submit_Enrich_Inline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Autofill — running`)
};

const zh_directory_submit_enrich_inline_title = /** @type {(inputs: Directory_Submit_Enrich_Inline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 自动填写 — 运行中`)
};

/**
* | output |
* | --- |
* | "AI Autofill — running" |
*
* @param {Directory_Submit_Enrich_Inline_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_inline_title = /** @type {((inputs?: Directory_Submit_Enrich_Inline_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Inline_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_inline_title(inputs)
	return zh_directory_submit_enrich_inline_title(inputs)
});
export { directory_submit_enrich_inline_title as "directory.submit.enrich.inline_title" }